import { Injectable } from '@angular/core';
import { Serialize } from 'cerialize';
import { map, Observable } from 'rxjs';
import { ChangePassword } from '../../models/api/change-password.model';
import { LoginBodyModel, LoginResponseModel } from '../../models/api/login.model';
import { RegistrationModel } from '../../models/api/registration.model';
import { UpdateUserModel, UserDetailModel, UserModel } from '../../models/api/user.model';
import { IResponseModel } from '../../models/interfaces/response-model.interface';
import { ApiConstants } from '../api.constant';
import { ApiDeleteRequest } from '../requests/api-delete.request';
import { ApiDetailsRequest } from '../requests/api-details.request';
import { ApiGetRequest } from '../requests/api-get.request';
import { ApiPatchRequest } from '../requests/api-patch.request';
import { ApiPostRequest } from '../requests/api-post.request';
import { ApiPutRequest } from '../requests/api-put.request';
import { ApiService } from './api.service';

@Injectable({
    providedIn: 'root'
})
export class UsersApiService extends ApiService<UserModel> {
    constructor() {
        super([ApiConstants.API_GROUP_USERS], UserModel);
    }

    public me(): Observable<UserDetailModel> {
        const request = new ApiGetRequest([...this.groups, ApiConstants.API_METHOD_ME], UserDetailModel);

        return this.apiRequestService.get(request);
    }

    public forgotPassword(email: string, teamName?: string): Observable<boolean> {
        const request = new ApiPostRequest([...this.groups, ApiConstants.API_METHOD_FORGOT_PASSWORD], this.model, { email, teamName });

        return this.apiRequestService.post(request).pipe(map(() => true)); // just return true if result
    }

    public register(registration: RegistrationModel): Observable<IResponseModel> {
        const request = new ApiPostRequest([...this.groups, ApiConstants.API_METHOD_REGISTER], this.model, registration);

        return this.apiRequestService.post(request);
    }

    public login(login: LoginBodyModel): Observable<LoginResponseModel> {
        const request = new ApiPostRequest([...this.groups, ApiConstants.API_METHOD_LOGIN], LoginResponseModel, login);

        return this.apiRequestService.post<LoginResponseModel>(request);
    }

    public logout(): Observable<boolean> {
        const request = new ApiDeleteRequest([...this.groups, ApiConstants.API_METHOD_LOGOUT]);

        return this.apiRequestService.delete(request);
    }

    public changePasswordMe(changePassword: ChangePassword): Observable<UserModel> {
        const request = new ApiPutRequest(this.groups, UserModel, ApiConstants.API_METHOD_ME, changePassword, ApiConstants.API_METHOD_CHANGE_PASSWORD);

        return this.apiRequestService.put(request);
    }

    public getUserDetails(id: string): Observable<UserDetailModel> {
        const request = new ApiDetailsRequest(this.groups, UserDetailModel, id);
        return this.apiRequestService.findOne(request);
    }

    public patchUserDetails(id: string, user: UpdateUserModel): Observable<UserDetailModel> {
        const request = new ApiPatchRequest(this.groups, UserDetailModel, id, Serialize(user, UpdateUserModel));
        return this.apiRequestService.patch(request);
    }

    public deleteUser(id: string): Observable<boolean> {
        return this.deleteOne(id);
    }
}
